﻿import * as MuiIcons from "@material-ui/icons";
import { TextField as MuiTextField, Tooltip } from "@material-ui/core";
import React, { RefObject, useState } from "react";
import { StandardTextFieldProps as MuiTextFieldProps } from "@material-ui/core/TextField";

export interface ITextFieldProps extends MuiTextFieldProps {
    characterlimit?: number;
    displaylimit?: boolean;
    infoText?: string;
    ref?: RefObject<HTMLDivElement>;
}

export const TextField: React.FunctionComponent<ITextFieldProps> = (
    props,
): React.ReactElement => {
    const [value, setValue] = useState<string>((props.value as string) || ``);

    const onType = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const textboxVal: string = event.currentTarget.value;

        let changeToVal: string = textboxVal;

        if (textboxVal.length > props.characterlimit) {
            changeToVal = value;
        }

        setValue(changeToVal);
        event.currentTarget.value = changeToVal;

        if (props.onChange) {
            props.onChange(event);
        }
    };

    const { infoText, ...otherProps } = props;

    const applyInfoWrapper = (
        textField: React.ReactElement,
    ): React.ReactElement => (
        <div className={`infoTag-container`}>
            {textField}
            <Tooltip title={infoText}>
                <MuiIcons.Info className={`infoTag`} />
            </Tooltip>
        </div>
    );

    const applyLimitWrapper = (
        textField: React.ReactElement,
    ): React.ReactElement => (
        <div className={`textfield-container`} style={props.style}>
            {textField}
            <div className={`textfield-countercontainer`}>
                <div className={`textfield-counter`}>
                    {value.length}/{props.characterlimit}
                </div>
            </div>
        </div>
    );

    /*
        Margin and padding to the right to push the scrollbar
        out of the view and overflowX on the parent to prevent
        this causing horizontal scrolling.
    */
    let textField: React.ReactElement = (
        <MuiTextField
            {...otherProps}
            inputProps={{
                style: {
                    marginRight: `-30px`,
                    paddingRight: `30px`,
                },
            }}
            onChange={onType}
            style={{ overflowX: `hidden` }}
            value={value}
        />
    );

    if (infoText) {
        textField = applyInfoWrapper(textField);
    }

    if (props.characterlimit && props.displaylimit) {
        return applyLimitWrapper(textField);
    } else {
        return textField;
    }
};
